import api from './api';

export interface Project {
  id: string;
  user_id: string;
  name: string;
  description?: string;
  slug: string;
  logo_url?: string;
  color: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  businessProfile?: {
    id: string;
    business_name?: string;
    logo_url?: string;
    onboarding_completed: boolean;
  };
}

export interface CreateProjectData {
  name: string;
  description?: string;
  logo_url?: string;
  color?: string;
}

export interface UpdateProjectData {
  name?: string;
  description?: string;
  logo_url?: string;
  color?: string;
  is_active?: boolean;
}

const getProjects = async (params?: { page?: number; limit?: number; search?: string }) => {
  const response = await api.get('/projects', { params });
  return response.data;
};

const getProject = async (id: string) => {
  const response = await api.get(`/projects/${id}`);
  return response.data;
};

const getProjectBySlug = async (slug: string) => {
  const response = await api.get(`/projects/slug/${slug}`);
  return response.data;
};

const createProject = async (data: CreateProjectData) => {
  const response = await api.post('/projects', data);
  return response.data;
};

const updateProject = async (id: string, data: UpdateProjectData) => {
  const response = await api.put(`/projects/${id}`, data);
  return response.data;
};

const archiveProject = async (id: string) => {
  const response = await api.delete(`/projects/${id}`);
  return response.data;
};

const deleteProject = async (id: string) => {
  const response = await api.delete(`/projects/${id}/permanent`);
  return response.data;
};

const switchProject = async (id: string) => {
  const response = await api.post(`/projects/${id}/switch`);
  return response.data;
};

const updateProjectProfile = async (id: string, data: any) => {
  const response = await api.put(`/projects/${id}/profile`, data);
  return response.data;
};

export const projectService = {
  getProjects,
  getProject,
  getProjectBySlug,
  createProject,
  updateProject,
  updateProjectProfile,
  archiveProject,
  deleteProject,
  switchProject
};

export default projectService;
